import { render, staticRenderFns } from "./lead-collector-section.vue?vue&type=template&id=2160f602"
import script from "./lead-collector-section.vue?vue&type=script&lang=js"
export * from "./lead-collector-section.vue?vue&type=script&lang=js"
import style0 from "./lead-collector-section.vue?vue&type=style&index=0&id=2160f602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports